import React from 'react';
import { Plan, today } from './model';
import { Verification, VerificationKind, setupTypes, verificationGroups } from './verification';
export function VerificationEditor({plan,kind,onSave}:{plan:Plan;kind:VerificationKind;onSave:(value:Verification)=>void}) {
  const previous=plan.verifications?.[kind];
  const fresh=previous&&(kind==='evidence'?plan.reviewDue>=today():previous.date===today());
  const [value,setValue]=React.useState<Verification>(fresh?{...previous,answers:{...previous.answers}}:{date:today(),setupType:'',answers:{}});
  const group=verificationGroups[kind];
  return <div className="tc-verification">
    <p>{group.description}</p>
    {kind==='setup'&&<div className="tc-dialog-tools" role="group" aria-label="Setup type">{setupTypes.map(type=><button key={type} aria-pressed={value.setupType===type} onClick={()=>{
      const answers={...value.answers};if(value.setupType!==type)delete answers.trigger;setValue({...value,setupType:type,answers});
    }}>{type}</button>)}</div>}
    {group.checks.map(check=><div className={`tc-check ${value.answers[check.id]||''}`} key={check.id}>
      <div><strong>{check.label}</strong><p>{check.detail}</p></div>
      {(['done','concern'] as const).map(answer=><button key={answer} className={answer==='done'?'tc-done':'tc-concern'} aria-label={`${answer==='done'?'Done':'Concern'}: ${check.label}`} aria-pressed={value.answers[check.id]===answer} onClick={()=>{
        const answers={...value.answers};if(answers[check.id]===answer)delete answers[check.id];else answers[check.id]=answer;setValue({...value,answers});
      }}>{answer==='done'?'✓':'!'}</button>)}
    </div>)}
    <p>✓ Checked · ! Concern · Unanswered items prevent GO.{kind!=='evidence'?' Recheck before a new entry; these confirmations expire each day.':''}</p>
    <button className="tc-primary" onClick={()=>onSave({...value,date:today()})}>Save review</button>
  </div>;
}
